import { TypeOfCancer } from '@/components/icons/icon-catch/types';
import riskRepository from '@/repositories/risk.repository';
import { useQuery } from '@tanstack/react-query';

export function useGetRisk() {
  return useQuery({
    queryKey: ['riskData', 'get'],
    queryFn: riskRepository.get,
  });
}

export function useGetRiskFactors() {
  return useQuery({
    queryKey: ['riskFactors', 'get'],
    queryFn: riskRepository.riskFactors,
  });
}

export function useGetRiskFactorsByCancer() {
  return useQuery({
    queryKey: ['riskFactorsByCancer', 'get'],
    queryFn: riskRepository.riskFactorsByCancer,
  });
}

export function useGetRiskTrend() {
  return useQuery({
    queryKey: ['riskTrend', 'get'],
    queryFn: riskRepository.riskTrend,
  });
}

export function useGetRiskAnalysisByCancerType(cancerType: TypeOfCancer) {
  return useQuery({
    queryKey: ['riskAnalysis', 'get', cancerType],
    queryFn: () => riskRepository.riskAnalysisByCancerType(cancerType),
  });
}
